import {css} from 'lit'; export default css`:host{align-items:center;display:flex;font-family:var(--goto-font-family);height:100%;justify-content:center;width:100%}.danger-icon{--goto-icon-color:var(--goto-danger-01)}`;
    